export const AUTHORIZE_PATH = '/authorize';
export const CHANGE_PASSWORD_PATH = '/change-password';
export const LOGIN_PATH = '/login';
export const LOGIN_REDIRECT_PATH = '/login-redirect';
export const LOGOUT_PATH = '/logout';
